import { setSavedCreditCards } from './reducer';
import { AppDispatch } from '..';
import { getUsersSavedCards } from './utils';

export const loadSavedCreditCards = (userID: string | undefined) => async (dispatch: AppDispatch) => {
  try {
    if (userID === undefined) {
      throw new Error('User ID is undefined');
    }
    const savedCreditCardsResponse = await getUsersSavedCards(userID);
    dispatch(setSavedCreditCards(savedCreditCardsResponse));

    return savedCreditCardsResponse;
  } catch (error) {
    console.error(error);
    dispatch(setSavedCreditCards([]));
  }
};
